import { render, staticRenderFns } from "./bundles.vue?vue&type=template&id=284eb86c"
import script from "./bundles.vue?vue&type=script&lang=js"
export * from "./bundles.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports